import { Tooltip } from "antd";
import classNames from "classnames";
import React from "react";

import AIStarIcon from "ac-components/ac-icons/AIStarIcon";

import "./ACAIBadge.less";

type ACAIBadgeProps = {
  tooltipText?: string;
  type?: string;
  className?: string;
};

const ACAIBadge = ({
  tooltipText = "Powered by AI",
  type,
  className,
}: ACAIBadgeProps) => {
  const remediationActionLink =
    "https://support.armorcode.com/hc/en-us/articles/32030338244499-Using-AI-Remediation";
  const correlateFindingsLink =
    "https://support.armorcode.com/hc/en-us/articles/28943534504467-Correlate-Findings";

  const tooltipContent = type ? (
    <div>
      <span>{tooltipText}, </span>
      <a
        href={
          type === "remediationAction"
            ? remediationActionLink
            : correlateFindingsLink
        }
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginLeft: "2px", color: "white" }}
      >
        Learn More
      </a>
    </div>
  ) : undefined;

  const content = (
    <div className={classNames("ac-ai-badge", className)}>
      <AIStarIcon style={{ fontSize: 15, margin: 0, padding: 0 }} />
      <span style={{ fontSize: "12px" }}>AI</span>
    </div>
  );

  if (tooltipContent) {
    return <Tooltip title={tooltipContent}>{content}</Tooltip>;
  }
  return <Tooltip title={tooltipText}>{content}</Tooltip>;
};

export default ACAIBadge;
